module.exports = __webpack_public_path__ + "img/Car park.56034e8a.png";